/* Twitter Carousel */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeHomeCarouselTwitter() {
    
    /* Setup */
    var container = jQuery( '#home-twitter' );
    
    /* Check For Container */
    if ( container.length ) {
        
        /* Get Carousel */
        var carousel = jQuery( '#home-twitter > div > div > div:first-child + div > ul' );
    
        /* Check For Slides */
        if ( carousel.children().length > 1 ) {
            
            /* Start Carousel */
            carousel.cycle({
                slides: '> li',
                pauseOnHover: true,
                swipe: true,
                autoHeight: 'calc',
                timeout: 3500
            });

            /* Trigger Resize To Set Correct Sentenial Height */
            carousel.data( 'cycle.API' ).trigger( 'resize' );

        }

    }

}

/* Home Carousel - Desktop */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeHomeCarouselDesktop() {
    
    /* Check For Slides */
    if ( jQuery( '#logo-carousel-desktop' ).children( 'ul' ).length > 1 ) {
        
        /* Add Next / Prev */
        jQuery( '#logo-carousel-desktop' ).append( '<i class="prev"></i><i class="next"></i>' );
        
        /* Start Carousel */
        jQuery( '#logo-carousel-desktop' ).cycle({
            slides: '> ul',
            pauseOnHover: true,
            swipe: true,
            timeout: 4000,
            prev: '#logo-carousel-desktop .prev',
			next: '#logo-carousel-desktop .next'
        });
        
        /* Pause */
        jQuery( '#logo-carousel-desktop' ).cycle( 'pause' );

    }

}

/* Home Carousel - Tablet */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeHomeCarouselTablet() {
    
    /* Check For Slides */
    if ( jQuery( '#logo-carousel-tablet' ).children( 'ul' ).length > 1 ) {
        
        /* Add Next / Prev */
        jQuery( '#logo-carousel-tablet' ).append( '<i class="prev"></i><i class="next"></i>' );
        
        /* Start Carousel */
        jQuery( '#logo-carousel-tablet' ).cycle({
            slides: '> ul',
            pauseOnHover: true,
            swipe: true,
            timeout: 4000,
            prev: '#logo-carousel-tablet .prev',
			next: '#logo-carousel-tablet .next'
        });
        
        /* Pause */
        jQuery( '#logo-carousel-tablet' ).cycle( 'pause' );

    }

}

/* Home Carousel - Mobile */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeHomeCarouselMobile() {
    
    /* Check For Slides */
    if ( jQuery( '#logo-carousel-mobile' ).children( 'ul' ).length > 1 ) {
        
        /* Add Next / Prev */
        jQuery( '#logo-carousel-mobile' ).append( '<i class="prev"></i><i class="next"></i>' );
        
        /* Start Carousel */
        jQuery( '#logo-carousel-mobile' ).cycle({
            slides: '> ul',
            pauseOnHover: true,
            swipe: true,
            timeout: 4000,
            prev: '#logo-carousel-mobile .prev',
			next: '#logo-carousel-mobile .next'
        });
        
        /* Pause */
        jQuery( '#logo-carousel-mobile' ).cycle( 'pause' );

    }

}

/* Home Carousel - Resize */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeHomeCarouselResize() {

    /* Desktop */
    if ( jQuery( '#logo-carousel-desktop' ).is(':visible') ) {
        jQuery( '#logo-carousel-desktop' ).cycle('resume');
    } else {
        jQuery( '#logo-carousel-desktop' ).cycle('pause');
    }

    /* Tablet */
    if ( jQuery( '#logo-carousel-tablet' ).is(':visible') ) {
        jQuery( '#logo-carousel-tablet' ).cycle('resume');
    } else {
        jQuery( '#logo-carousel-tablet' ).cycle('pause');
    }

    /* Mobile */
    if ( jQuery( '#logo-carousel-mobile' ).is(':visible') ) {
        jQuery( '#logo-carousel-mobile' ).cycle('resume');
    } else {
        jQuery( '#logo-carousel-mobile' ).cycle('pause');
    }

}

/* Cycle Init */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeCycleInit() {
    
    /* Home Carousel - Twitter */
    ipcrimeHomeCarouselTwitter();

    /* Home Carousel - Desktop */
    ipcrimeHomeCarouselDesktop();
    
    /* Home Carousel - Tablet */
    ipcrimeHomeCarouselTablet();
    
    /* Home Carousel - Mobile */
    ipcrimeHomeCarouselMobile();
    
    /* Home Carousel - Resize */
    if ( jQuery( '#logo-carousel-desktop' ).length ) {
        ipcrimeHomeCarouselResize();
        jQuery(window).on( 'resize.home-carousel' , function() {
            ipcrimeHomeCarouselResize();
        });
    }

}